import { detectResourcesSync, envDetectorSync, processDetectorSync, hostDetectorSync } from '@opentelemetry/resources';
import { Resource } from './Resource';

export class ServerAppResource extends Resource {
  private constructor() {
    super();
  }

  static create(): ServerAppResource {
    try {
      const resource = new ServerAppResource();

      const detectedResources = detectResourcesSync({
        detectors: [envDetectorSync, processDetectorSync, hostDetectorSync],
      });

      resource.merge(detectedResources);

      return resource;
    } catch {
      return new ServerAppResource();
    }
  }
}
